import { render, staticRenderFns } from "./VorstossCard.vue?vue&type=template&id=451712f8"
import script from "./VorstossCard.vue?vue&type=script&lang=js"
export * from "./VorstossCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports